import { UsersHook } from "@models";
import { useStore } from "@stores";
import { useEffect, useMemo } from "react";

interface IProps {
  tenantId: string | undefined;
  workerId: string | number | undefined;
}

export const useWorkers = ({ tenantId, workerId }: IProps): UsersHook => {
  const { userStore } = useStore();
  const { loading, users } = userStore;

  useEffect(() => {
    tenantId && userStore.getAllByTenantId(tenantId);

    return () => userStore.clearUsers();
  }, [userStore, tenantId]);

  const dataSource = Array.from(users.values());

  const userOptions = useMemo(
    () => dataSource.map((x) => ({ key: x.id, value: x.id, label: `${x.name} ${x.surname}` })),
    [dataSource]
  );

  const fullName = useMemo(() => {
    if (!workerId) return "";
    const user = dataSource.find((x) => x.id === workerId);
    return user ? `${user.name} ${user.surname}` : "";
  }, [dataSource, workerId]);

  return {
    dataSource,
    loading,
    userOptions,
    fullName,
  };
};
